<app-generic-field [label]="label" [hideLabel]="hideLabel">
    <p-calendar #calendar [(ngModel)]="stringValue" keepInvalid="true" dataType="string" appendTo="body"
                (onBlur)="dateHandler()" [inputStyle]="{'height':'30px'}" [panelStyle]="{transform: 'translateY(100px)'}"
                (focus)="calendarFocus()" (onSelect)="dateSelect($event)">
    </p-calendar>
</app-generic-field>
